import { render, staticRenderFns } from "./genre-options.vue?vue&type=template&id=3ac81e60&scoped=true"
import script from "./genre-options.vue?vue&type=script&setup=true&lang=js"
export * from "./genre-options.vue?vue&type=script&setup=true&lang=js"
import style0 from "./genre-options.vue?vue&type=style&index=0&id=3ac81e60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ac81e60",
  null
  
)

export default component.exports